<template>
    <div v-if="this.$route.name != 'login'">
        <!-- <div id="footer-bar" class="footer-bar footer-bar-detached"> -->
        <div id="footer-bar" class="footer-bar">
            <router-link :to="{ name: 'home' }"><i class="bi bi-book-fill font-17"></i><span>Home</span></router-link>
            <router-link :to="{ name: 'khazanah.index' }"><i class="bi bi-bookshelf font-15"></i><span>Khazanah</span></router-link>
            <router-link v-if="$store.state.token" :to="{ name: 'bookmark' }"><i class="bi bi-bookmark-fill font-16"></i><span>Bookmark</span></router-link>
            <!-- <router-link :to="{ name: 'login' }"><i class="bi bi-people font-16"></i><span>Login</span></router-link> -->
            <a href="javascript:void(0)" v-if="!$store.state.token" @click="login"><i class="bi bi-people font-16"></i><span>Login</span></a>
            <a href="javascript:void(0)" v-if="$store.state.token" @click="logout"><i class="bi bi-people font-16"></i><span>Logout</span></a>
        </div>

        <a data-toast="toast-login-success" ref="toastLoginSuccess" href="#"></a>
        <!-- Success Toast Bar-->
        <div id="toast-login-success" class="toast toast-bar toast-top rounded-l bg-green-dark shadow-bg shadow-bg-s" data-bs-delay="3000">
            <div class="align-self-center">
                <i class="icon icon-s bg-green-light rounded-l bi bi-check font-28 me-2"></i>
            </div>
            <div class="align-self-center ps-1">
                <strong class="font-13 mb-n2">Pemberitahuan</strong>
                <span class="font-10 mt-n1 opacity-70">Anda Berhasil Login</span>
            </div>
            <div class="align-self-center ms-auto">
                <button type="button" class="btn-close btn-close-white me-2 m-auto font-9" data-bs-dismiss="toast"></button>
            </div>
        </div>

        <a data-toast="toast-logout-success" ref="toastLogoutSuccess" href="#"></a>
        <!-- Success Toast Bar-->
        <div id="toast-logout-success" class="toast toast-bar toast-top rounded-l bg-green-dark shadow-bg shadow-bg-s" data-bs-delay="3000">
            <div class="align-self-center">
                <i class="icon icon-s bg-green-light rounded-l bi bi-check font-28 me-2"></i>
            </div>
            <div class="align-self-center ps-1">
                <strong class="font-13 mb-n2">Pemberitahuan</strong>
                <span class="font-10 mt-n1 opacity-70">Anda Berhasil Logout</span>
            </div>
            <div class="align-self-center ms-auto">
                <button type="button" class="btn-close btn-close-white me-2 m-auto font-9" data-bs-dismiss="toast"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { GoogleAuthProvider, signInWithPopup, getAuth } from 'firebase/auth'
import { mapActions } from 'vuex'
import cookie from 'vue-cookie'

export default {
    name: 'Footer',
    methods: {
        ...mapActions('auth', ['loginByGoogle']),
        login() {
            const provider = new GoogleAuthProvider()
            const auth = getAuth()

            signInWithPopup(auth, provider)
                .then((result) => {
                    this.loginByGoogle({
                        email: result.user.email,
                        uid: result.user.uid
                    })
                        .then(() => {
                            this.$refs.toastLoginSuccess.click()
                            let route = this.$route.name
                            if(route != 'home') {
                                this.$router.push({ name: 'home' })
                            }
                        })
                        .catch(err => console.log(err))
                })
                .catch(error => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log(errorCode, errorMessage)
                })
        },
        logout() {
            cookie.delete('token');
            cookie.delete('userProfile');
            this.$store.dispatch('changeProfile', {
                name: '',
                email: '',
                image: ''
            });
            this.$router.push({ name: 'login' });
        }
    }
}
</script>